/**
 * invoiceService — Invoice PDF retrieval
 *
 * Architecture:
 * - Invoices are PDFs dropped into an Azure Data Lake folder
 *   by an external invoicing application via REST API.
 * - MRT simply retrieves, displays, downloads — no write operations.
 *
 * Mock data sourced from BrightStars Incorp. demo customer (demoData.js).
 */
import { DEMO_INVOICES } from '@data/demoData';

/**
 * Get all invoices for the current customer account
 * @param {Object} [filters] - { dateFrom, dateTo, status }
 * @returns {Promise<Array>} Array of invoice objects
 */
export async function getInvoices(filters = {}) {
  // Simulate network delay for realistic loading state
  await new Promise(r => setTimeout(r, 300));
  return DEMO_INVOICES;
}

/**
 * Get invoice PDF download URL
 * @param {string} invoiceId
 * @returns {Promise<string>} Signed download URL
 */
export async function getInvoicePdfUrl(invoiceId) {
  console.log('[invoiceService] PDF download requested (stub):', invoiceId);
  return `/api/invoices/${invoiceId}/pdf`;
}
